import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ClipLoader } from "react-spinners";

import config from "../config.json";
import Card from "./Card";
import CardPage from "./CardPage";
import Header from "./Header";
import "./walletStyles.scss";

import { CardContext } from "../context/CardContext";
import { LanguageContext } from "../context/languageContext";
import { useNftsLoad } from "../hooks/useNftsLoad";
import { useExperienceCards } from "./useExperienceCards";

const Wallet = () => {
  const address = "0xabfea1afbcB083f700Fb0b603a550Ed1BEe5BC8A";
  const { usersCrest } = useExperienceCards(address);
  const { collections, contentLoaded, error, mintedCollectionIds } =
    useNftsLoad(address);

  const { setCollectionList } = useContext(CardContext);
  const [cardIsShown, setCardIsShown] = useState(false);
  const [source, setSource] = useState("osszes");

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedArray, setSelectedArray] = useState([]);

  const [allCardsShown, setAllCardsShown] = useState(true);
  const [ownedCardsShown, setOwnedCardsShown] = useState(false);
  const [addressShown, setAddressShown] = useState(false);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const goToCardPage = (id) => {
    navigate(`/experience/${id}${address ? "?address=" + address : ""}`);
  };

  const goToCardPageForOwned = (id) => {
    navigate(`/experience/${id}${address ? "?address=" + address : ""}`);
  };

  const hideCardPage = () => {
    setCardIsShown(false);
  };

  const link = `https://polygonscan.com/address/${address}`;

  useEffect(() => {
    //only at the muzeum style needed
    //document.documentElement.style.backgroundColor = "white";
    if (cardIsShown) {
      document.body.style.backgroundColor = "#5A513F";
    } else {
      document.body.style.backgroundColor = "#fff";
    }
  }, [cardIsShown]);
  useEffect(() => {
    setCollectionList(collections);
  }, [collections]);

  return (
    <>
      {cardIsShown ? (
        <CardPage
          handleClick={hideCardPage}
          source={source}
          ownedCards={collections.filter((item) => item.owned === true)}
          allCards={selectedArray}
          selectedIndex={selectedIndex}
          address={address}
        />
      ) : (
        <>
          <div className="wallet">
            <Header />
            <div className="wallet-container">
              <div className="wallet-title">
                <h1
                  style={{
                    color: config.MUZEUM.titleColor,
                    fontFamily: config.MUZEUM.extraBoldFont,
                    // WebkitTextStroke: `1px ${config.CAMELCODING.titleColor}`,
                  }}
                >
                  {t("title2")}
                </h1>
                <p
                  style={{
                    color: config.MUZEUM.textColor,
                    fontFamily: config.MUZEUM.semiboldFont,
                  }}
                >
                  {t("walletText")}
                </p>
              </div>

              {addressShown && (
                <div
                  className="address"
                  style={{ color: config.MUZEUM.textColor }}
                >
                  <p
                    className="wallet-address"
                    style={{
                      fontFamily: config.MUZEUM.font,
                      color: config.MUZEUM.textColor,
                    }}
                  >
                    {t("addressTabText")}
                  </p>
                  <a
                    href={link}
                    target="_blank"
                    className="address-link"
                    style={{ color: config.MUZEUM.textColor }}
                  >
                    {address}
                  </a>
                </div>
              )}
              {allCardsShown && (
                <div className="card-holder">
                  <>
                    {contentLoaded ? (
                      <div className="cards">
                        {collections.map((item, index) => {
                          return (
                            <Card
                              key={item.id}
                              cardItem={item}
                              onClick={
                                mintedCollectionIds.includes(item.id)
                                  ? () => goToCardPageForOwned(item.id)
                                  : () => goToCardPage(item.id)
                              }
                              isOwned={item.owned}
                              index={index}
                            />
                          );
                        })}
                      </div>
                    ) : (
                      <div className="loader">
                        <ClipLoader
                          color={"#999999"}
                          loading={!contentLoaded}
                          size={100}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    )}
                  </>
                </div>
              )}
              {ownedCardsShown && (
                <div className="card-holder">
                  <>
                    {contentLoaded ? (
                      <>
                        <div className="cards">
                          {collections.filter((item) => item.owned === true)
                            ?.length !== 0 ? (
                            collections
                              .filter((item) => item.owned === true)
                              .map((item, index) => {
                                //console.log(url, "metadata uri");
                                return (
                                  <Card
                                    key={index}
                                    name={item.name}
                                    cardItem={item}
                                    onClick={goToCardPageForOwned}
                                    isOwned={item.owned}
                                    index={index}
                                  />
                                );
                              })
                          ) : (
                            <div
                              className="no-cards"
                              style={{ color: config.MUZEUM.textColor }}
                            >
                              Még nem gyűjtöttél egyetlen kártyát sem.
                            </div>
                          )}
                        </div>
                      </>
                    ) : (
                      <div className="loader">
                        <ClipLoader
                          color={"#999999"}
                          loading={!contentLoaded}
                          size={100}
                          aria-label="Loading Spinner"
                          data-testid="loader"
                        />
                      </div>
                    )}
                  </>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Wallet;
